import React, { Fragment, useState, useEffect, useMemo, useCallback } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { StaticContext } from 'react-router-dom'
import { uniq } from 'lodash'
import { IonText, IonIcon, IonImg, IonChip, IonLabel, IonSelect, IonSelectOption, IonToggle } from '@ionic/react'

import caretDown from '../../assets/icons/icn_arrow-closed.svg'
import caretOpen from '../../assets/icons/icn_arrow-open.svg'

import Garbage from './../../assets/icons/act_delete.svg'
import Edit from './../../assets/icons/act_edit.svg'
import { image } from 'ionicons/icons'

import { ProviderModel } from '../../models/ProviderModel'
import { Product } from '../../models/ProductModel'
import TermsConditionsCoupons from '../terms-conditions-coupons/TermsConditionsCoupons'

import { formatCurrency } from '../../utils/intl'
import { returnOptionsToUOM } from '../../utils/uomAndPackage'

import { applyCouponEvent, eventForCart, registerBasicUserInfoEvent, sendMetric } from '../firebase/firebaseTags'
import { GuruBottomSheetModal } from '../../components'

import { verifyProviderReferal, getCartClient } from '../../clients/cart'
import { applyCouponToCart, removeCouponFromCart } from '../../clients/coupon'
import { VisibilityTracker } from '../../hoc'

import './CardCart.scss'


interface IPathParams {}

interface RouteState {}

type Props = RouteComponentProps<IPathParams, StaticContext, RouteState> & {
  providerModel: ProviderModel
  products: string
  provider: any
  paymentMethodByVendors: any
  showModal: (providerId: string, sku: string, product: any) => void
  renderModal: any
  deleteProduct: any
  productCart: any
  isMinimumFulfilled: boolean
  couponAddCart: any[]
  totalProvider: number
  totalToPay: (total: number) => void
  couponsActivatedList: any
  onOpenChangeWayToPay: any
  changeCart: (providerId: string) => void
  openProviderSelect: string
  addCouponCart: any
  removeCouponToCart: any
  isBottomSheetShow: (isShowBottomSheet: boolean) => void
  paymentMethodsByVendor: any
  vendorsShippingCost: any
}

const CardCartNew: React.FC<Props> = (props) => {
  const {
    paymentMethodByVendors,
    provider,
    productCart,
    isMinimumFulfilled,
    couponAddCart,
    totalProvider,
    couponsActivatedList,
    changeCart,
    openProviderSelect,
    addCouponCart,
    removeCouponToCart,
    isBottomSheetShow,
    paymentMethodsByVendor,
    products,
    vendorsShippingCost,
  } = props
  const [defautOpenCard, setDefautOpenCard] = useState<any>(null)
  const [bottomSheetShow, setBottomSheetShow] = useState(false)
  const [isOpenTermsConditionsCoupons, setIsOpenTermsConditionsCoupons] = useState(false)
  const [selectedCouponId, setSelectedCouponId] = useState(null)
  const [, setShowShowSelectedCouponId] = useState(null)
  const [lastAction, setLastAction] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isVendorInBlacklist, setIsVendorInBlacklist] = useState<boolean>(true)

  const removeCouponByAmount = useCallback(
    async (couponActivatedCart: any) => {
      if (couponActivatedCart?.providerId === provider?.id && couponActivatedCart?.minimumAmount >= totalProvider) {
        const idCoupon = {
          value: couponActivatedCart.couponId,
        }
        await removeCouponToCart(idCoupon, provider?.id)
      }
    },
    [provider, removeCouponToCart, totalProvider],
  )

  const get = useCallback(async () => {
    const oneVendor = uniq(productCart.products.map((item: any) => item.providerId))
    const cardSelect = oneVendor.length === 1
    setDefautOpenCard(cardSelect)
    const couponActivatedCart = productCart?.discounts.find((activated: any) => activated.providerId === provider.id)
    couponActivatedCart && setSelectedCouponId(couponActivatedCart.couponId)
    couponActivatedCart && removeCouponByAmount(couponActivatedCart)
  }, [productCart, provider.id, removeCouponByAmount])

  useEffect(() => {
    get()
    // eslint-disable-next-line 
  }, [])

  const allCoupons = useMemo(() => couponsActivatedList, [couponsActivatedList])

  const validateVendorsInBlacklist = useCallback(async () => {
    if (!couponsActivatedList.length) return
    let blockVendorsIds: any = []
    let validCouponsTypes = couponsActivatedList?.map((coupon: any) => coupon.couponType)
    let singleCouponsTypes = Array.from(new Set(validCouponsTypes))

    for (let i = 0; i < singleCouponsTypes.length; i++) {
      const couponType: any = singleCouponsTypes[i]
      const vendorsBlacklistInResponse = await vendosInBlacklist(couponType)
      const vendorsInBlacklist = vendorsBlacklistInResponse?.respuesta[0]?.providers || []

      blockVendorsIds = [...blockVendorsIds, ...vendorsInBlacklist]
    }

    setIsVendorInBlacklist(blockVendorsIds.includes(provider?.id))
  }, [couponsActivatedList, provider])

  useEffect(() => {
    validateVendorsInBlacklist()
  }, [allCoupons, validateVendorsInBlacklist])

  const findShippingCost = () => {
    if (vendorsShippingCost) {
      return vendorsShippingCost[products] || null
    }
    return null
  }

  const handleWhenProviderProductVisible = (product) => {
    registerBasicUserInfoEvent({
      eventName: 'cart_page_provider_list_product_view',
      placementName: 'cart',
      item_id: product.id,
      item_sku: product.sku,
      item_name: product.name,
      item_category: product.category

    })
  }

  const renderProducts = () => {
    return (
      provider &&
      paymentMethodByVendors.products[provider.id].map((product: any) =>
        paymentMethodByVendors.vendors[provider.id].map((productInCart: any) => {
          const uomProduct = findPairToShowValue(returnOptionsToUOM(), product?.UOM)
          const unitOfMeasure = uomProduct === 'unidad' ? 'unid.' : uomProduct

          return (
            productInCart &&
            product &&
            productInCart.sku === product.sku && (
              <VisibilityTracker onVisible={() => handleWhenProviderProductVisible(product)} >
                <div className="provider-product" key={product.sku}>

                  <h1>{productInCart.quantity}</h1>
                  {product.filename ? (
                    <div>
                      <IonImg className="product-image" src={product.filename}  />
                    </div>
                  ) : (
                    <div className="not-img">
                      <IonIcon className="product-image" icon={image}  />
                    </div>
                  )}
                  <div className="product-info">
                    <p className="paragraph-3">{`${product.name.slice(0, 19)}...`}</p>
                    <p className="paragraph-3">{`${product.units} ${unitOfMeasure} por ${product.package}`}</p>
                    <div className="color-price" key={product.sku}>
                      {formatCurrency(productInCart.infoPrice.totalPrice)}
                    </div>
                  </div>
                  <div className="product-operations">
                    <IonChip outline className="product-operation" >
                      <IonIcon
                        className="icon"
                        src={Edit}
                        onClick={() => {
                          onEditProduct(provider?.id, product.sku, product, productInCart)
                        } }                     />
                    </IonChip>
                    <IonChip outline className="product-operation" >
                      <IonIcon
                        className="icon"
                        src={Garbage}
                        onClick={async () => {
                          onDeleteProduct(productInCart, product)
                        } }                     />
                    </IonChip>
                  </div>
                </div>
              </VisibilityTracker>
            )
          )
        }),
      )
    )
  }

  const findPairToShowValue = (options: any, name: string) => options[name]

  const doesNotMeettheMinimum = () => {
    return (
      <div className="container-minimun">
        <div className="text-minimun paragraph-2">
          <IonText >
            {'Mínimo para entrega '}
            <IonText className="provider-minimum" >{formatCurrency(provider?.minimun)}</IonText>
          </IonText>
        </div>
        <div className="provider-button">
          <div
            className="div-button"
            onClick={() => {
              onCompleteProduct(provider)
            }}
          >
            Completar
          </div>
        </div>
      </div>
    )
  }

  const onCompleteProduct = (provider: any) => {
    const { alias, minimun, banners, id } = provider

    registerBasicUserInfoEvent({
      eventName: 'cart_page_provider_list_ask_to_complete_order_button_click',
      placementName: 'cart',
    })

    // sendMetric('complete_cart')
    props?.history?.push(`/home-providers/${id}`, {
      singleProviderId: id,
      nameProvider: alias,
      minumun: minimun,
      banners,
    })
  }

  const onEditProduct = (providerId: any, sku: any, product: Product, cartProduct: any) => {
    const { showModal, renderModal } = props

    registerBasicUserInfoEvent({
      eventName: 'cart_page_provider_list_product_edit',
      placementName: 'cart',
      item_id: product.id,
      item_sku: product.sku,
      item_name: product.name,
      item_category: product.category
    })

    const productEdit = { id: providerId }
    localStorage.setItem('onEditProduct', JSON.stringify(productEdit))

    showModal(providerId, sku, product)
    renderModal(cartProduct, product)
  }

  const onDeleteProduct = async (cartProduct: any, product: Product) => {
    const { deleteProduct } = props
    registerBasicUserInfoEvent({
      eventName: 'cart_page_provider_list_product_delete',
      placementName: 'cart',
      item_id: product.id,
      item_sku: product.sku,
      item_name: product.name,
      item_category: product.category

    })
    // eventForCart('delete_product_cart', product.name, product.id, product.brand, product.category, 'cart')
    await deleteProduct(cartProduct, product)
  }

  const nameProvider = () => {
    return (
      <div
        className="provider-header-cart"
        onClick={() => {
          changeCardSelect(provider?.id)
        }}
      >
        <div className="container-provider-header">
          <div className="h6-text">{provider?.alias}</div>
          <div className="icon-provider">
            <IonIcon
              className="icon"
              icon={isCardSelect(provider?.id, provider?.name) ? caretOpen : caretDown}
              onClick={() => {
                changeCardSelect(provider?.id)
              } }             />
          </div>
        </div>
      </div>
    )
  }

  const changeCardSelect = (providerId: string) => {
    const providerSelect = providerId === openProviderSelect ? '' : providerId
    changeCart(providerSelect)
    setDefautOpenCard(null)
  }

  const totalProviderCart = () => {
    const shippingCost = findShippingCost()
    const cartLocalStorage = localStorage.getItem('@cart')
    let cart: any = ''

    if (cartLocalStorage) cart = JSON.parse(cartLocalStorage)

    return (
      <div className="provider-footer">
        {shippingCost !== null && (
          <div className="provider-total">
            <div className="provider-total-info">
              <h6>Costo de despacho</h6>
              <h6>{`${shippingCost > 0.1 ? formatCurrency(shippingCost) : '¡Gratis!'}`}</h6>
            </div>
          </div>
        )}
        <div className="provider-total">
          <div className="provider-total-info">
            <span>Total</span>
            {(() => {
              // Cupón v2: el descuento sale del carro del SERVIDOR (appliedV2, la misma
              // fuente que el badge "CUPÓN APLICADO"). El cálculo legacy se mantiene,
              // pero EXCLUYENDO las entradas v2 (que también llegan al cache local via
              // sync y a couponAddCart) para no restar el mismo descuento dos veces.
              const isV2Discount = (d: any) => !!d && (d.source === 'coupon-v2' || d.cupon_id)
              const v2Discount = appliedV2
                ? Number(appliedV2.descuento_real ?? appliedV2.realDiscount ?? 0)
                : 0
              const localLegacy = ((cart && cart.discounts) || []).filter((d: any) => !isV2Discount(d))
              const legacyList = (couponAddCart || []).filter((d: any) => !isV2Discount(d))
              const legacyDiscount =
                verificarDescuento(provider, localLegacy) > 0
                  ? verificarDescuento(provider, legacyList)
                  : 0
              return <h6>{formatCurrency(totalProvider - legacyDiscount - v2Discount)}</h6>
            })()}
          </div>
        </div>
      </div>
    )
  }

  const verificarDescuento = (proveedor: any, coupon: any) => {
    let totalToDiscount = 0
    const result = coupon.filter((detail: any) => detail.providerId === proveedor.id)

    if (result.length > 0) totalToDiscount = result[0].realDiscount

    props.totalToPay(totalToDiscount)
    return totalToDiscount
  }

  const selectPaymentMethod = () => {
    const paymentMethodsText: any = {
      'pre-pago': 'anticipado',
      'post-pago': 'contra entrega',
      credito: 'crédito proveedor',
    }

    const placeholderSelect = `Pago ${paymentMethodsText[paymentMethodByVendors.paymentMethod]}`
    const uniqPaymentMethodsByVendor = uniq(paymentMethodsByVendor?.whitelist)

    return (
      <div className="way-to-pay-card">
        <IonSelect
          className="select-way-to-pay"
          mode="md"
          interface="action-sheet"
          cancelText="Cancelar"
          placeholder={placeholderSelect}
          onIonChange={(e) => {
            props.onOpenChangeWayToPay(e, provider?.id)
          } }
          interfaceOptions={{
            className: 'paymenth-options-cart-container',
          }}         >
          {uniqPaymentMethodsByVendor.map((paymentMethod: any) => {
            const optionText = paymentMethodsText[paymentMethod]
            if (!optionText || paymentMethodByVendors.paymentMethod === paymentMethod) return ''
            return (
              <IonSelectOption value={paymentMethod} key={paymentMethod} >
                Pago {optionText}
              </IonSelectOption>
            )
          })}
        </IonSelect>
      </div>
    )
  }

  const isCardSelect = (providerId?: string, providerName?: string) => {
    if (defautOpenCard !== null) return defautOpenCard

    let isInfoCard = openProviderSelect === provider?.id
    return isInfoCard
  }

  const vendosInBlacklist = async (couponType: string) => {
    const vendors = await verifyProviderReferal(couponType)
    return vendors
  }

  const renderCoupons = () => {
    const couponsActivatedCart = productCart?.discounts.find((activated: any) => activated.providerId === provider?.id)
    const validCoupons = couponsActivatedList.filter(
      (coupon: any) => coupon.validVendors && coupon.validVendors.length > 0,
    )
    const includeProvider =
      validCoupons.length > 0 && validCoupons.some((coupon: any) => coupon.validVendors.includes(provider.id))
    const hasValidCoupons = couponsActivatedList.length > validCoupons.length
    const couponsVendors = !includeProvider
      ? couponsActivatedList
          .filter((item: any) => item.validVendors.length === 0)
          .filter((item: any) => item.vendors.length === 0 || item.vendors.includes(provider?.id))
      : couponsActivatedList
    const couponText = availableCoupons?.length > 1 ? 'cupones disponibles' : 'cupón disponible'

    return (
      <div className="container-coupons">
        {couponsActivatedCart &&
        Object.keys(couponsActivatedCart).length > 0 &&
        couponsActivatedCart.providerId === provider?.id ? (
          <div className="coupons-activated">
            <div className="text-coupon">¡Descuento aplicado!</div>
            <div
              className="see-more"
              onClick={() => {
                showBottomSheet()
                setShowShowSelectedCouponId(provider?.id)
              }}
            >
              Ver Todos
            </div>
          </div>
        ) : (
          (hasValidCoupons || (validCoupons.length > 0 && includeProvider)) &&
          couponsVendors.length > 0 && (
            <div className="coupons-not-activated">
              <div className="text-coupon">
                Tienes {availableCoupons?.length} {couponText}
              </div>
              <div
                className="see-more"
                onClick={() => {
                  showBottomSheet()
                  setShowShowSelectedCouponId(provider?.id)
                }}
              >
                Ver Todos
              </div>
            </div>
          )
        )}
      </div>
    )
  }

  const renderBottomSheet = () => {
    return (
      <div className="container-bottom-sheet">
        {bottomSheetShow && (
          <GuruBottomSheetModal
            isOpen={bottomSheetShow}
            onClose={() => showBottomSheet()}
            customHeight={70} // Ajustado de 200px a un porcentaje aproximado
          >
            <div className="info-bottom-sheet">
              <div className="btn-close" onClick={() => showBottomSheet()}></div>
              <div className="title-text">Cupones</div>
              <div className="sheet-text paragraph-2">
                Al aplicar cualquier cupón estás
                <div className="underlined" onClick={() => setIsOpenTermsConditionsCoupons(true)}>
                  aceptando los términos y condiciones.
                </div>
              </div>
              {availableCoupons.length > 0 && showListCoupons()}
            </div>
          </GuruBottomSheetModal>
        )}
      </div>
    )
  }

  const showListCoupons = () => {
    const couponActivatedCart = productCart?.discounts.find((activated: any) => activated.providerId === provider?.id)

    return availableCoupons.map((item: any) => {
      let checked = item.couponId === couponActivatedCart?.couponId
      const minimumAmountCoupon = totalProvider >= item?.couponInfo.minimum_amount
      const isCouponDisabled = (selectedCouponId && !checked) || !minimumAmountCoupon

      return (
        <div className={`card-cupons ${isCouponDisabled ? 'disabled' : ''}`} key={item.couponId}>
          <div className="container-img-cupons">
            <IonImg
              className="image-cupons"
              src={`${process.env.REACT_APP_BFF_IMAGE}coupons/${item?.couponInfo?.image?.url}`}             />
          </div>
          <div className="info">
            <h5 className="info-title">
              {item.discount_type === 'porcent'
                ? `${item?.couponInfo.amount}%`
                : formatCurrency(item?.couponInfo.amount)}{' '}
              {`de descuento`}
            </h5>
            <div className="paragraph-3">
              {`Compras sobre`} {formatCurrency(item?.couponInfo.minimum_amount)}
            </div>
          </div>
          <div className="container-toggle">
            <IonToggle
              checked={checked}
              value={item.couponId}
              mode="ios"
              disabled={!!isCouponDisabled}
              onIonChange={async (e) => {
                if (isLoading) return

                const existInCart = item.couponId === couponActivatedCart?.couponId

                if (!existInCart && e.detail.checked && lastAction !== 'add') {
                  applyCouponEvent(item?.code)
                  setIsLoading(true)
                  setLastAction('add')
                  setSelectedCouponId(item._id)
                  await addCouponCart(e.detail, provider?.id)
                  setIsLoading(false)
                }

                if (existInCart && !e.detail.checked && lastAction !== 'remove') {
                  setIsLoading(true)
                  setLastAction('remove')
                  setSelectedCouponId(null)
                  await removeCouponToCart(e.detail, provider?.id)
                  setIsLoading(false)
                }
              } }             />
            <IonLabel >Aplicar</IonLabel>
          </div>
        </div>
      )
    })
  }

  const showBottomSheet = () => {
    setBottomSheetShow(!bottomSheetShow)
    isBottomSheetShow(!bottomSheetShow)
  }

  const closeTermsConditionsCoupons = () => setIsOpenTermsConditionsCoupons(false)

  let wayToPay = uniq(paymentMethodsByVendor?.whitelist.map((item: any) => item))

  const availableCoupons = useMemo(() => {
    const coupons = isVendorInBlacklist
      ? couponsActivatedList.filter(({ couponType }: any) => couponType === 'full-coupon')
      : couponsActivatedList

    const validCoupons = coupons.filter((coupon: any) => coupon.validVendors && coupon.validVendors.length > 0)
    const includeProvider =
      validCoupons.length > 0 ? validCoupons.filter((coupon: any) => coupon.validVendors.includes(provider?.id)) : []
    const couponsWithoutValidVendors = coupons.filter((item: any) => item.validVendors.length === 0)
    const couponsVendors =
      includeProvider.length === 0 ? couponsWithoutValidVendors : [...couponsWithoutValidVendors, ...includeProvider]
    return couponsVendors.filter((item: any) => item.vendors?.length === 0 || item.vendors.includes(provider?.id))
  }, [couponsActivatedList, isVendorInBlacklist, provider])

  // ── Cupón v2 (marketplace): input autocontenido por proveedor ──
  const [codigoV2, setCodigoV2] = useState('')
  const [applyingV2, setApplyingV2] = useState(false)
  const [errorV2, setErrorV2] = useState('')
  const cartIdV2 = (props as any).cartId || productCart?.id || productCart?._id
  const appliedV2 = (productCart?.discounts || []).find(
    (d: any) =>
      (d?.source === 'coupon-v2' || d?.cupon_id) &&
      String(d?.proveedor_id) === String(provider?.id) &&
      d?.aplica !== false,
  )
  // OrderConfirmation arma el pedido leyendo localStorage['@cart'] (via CartModel),
  // no el carro fresco del servidor. Sin este sync, el cupon v2 queda aplicado en
  // el backend pero nunca llega al pedido, porque ese cache nunca se actualiza.
  const syncLocalCartDiscounts = async (cartIdToSync: string) => {
    try {
      const fresh = await getCartClient(cartIdToSync)
      // /v1/carts/:id devuelve el carro anidado ({ cart, unavailableProducts }) cuando
      // hay productos, o plano cuando esta vacio. Contemplamos ambas formas.
      const freshDiscounts = fresh?.data?.cart?.discounts || fresh?.data?.discounts
      if (!freshDiscounts) return
      const raw = localStorage.getItem('@cart')
      const cached = raw ? JSON.parse(raw) : {}
      cached.discounts = freshDiscounts
      localStorage.setItem('@cart', JSON.stringify(cached))
    } catch (e) {
      // Si falla el sync, se sigue con reload igual; el usuario vera el estado del servidor.
    }
  }
  const applyCouponV2 = async () => {
    const code = codigoV2.trim().toUpperCase()
    if (!code) return
    setApplyingV2(true)
    setErrorV2('')
    try {
      const res = await applyCouponToCart(cartIdV2, code)
      if (res && res.ok === false) {
        setErrorV2(res.mensaje || res.motivo || 'Cupón no válido')
        return
      }
      await syncLocalCartDiscounts(cartIdV2)
      window.location.reload()
    } catch (e: any) {
      // El backend manda { ok:false, motivo, mensaje } (espanol) - no .message.
      // Ese mismatch de nombre era la causa de que siempre se mostrara el generico.
      const data = e?.response?.data
      setErrorV2((data && (data.mensaje || data.motivo)) || (typeof data === 'string' && data) || 'No se pudo aplicar el cupón')
    } finally {
      setApplyingV2(false)
    }
  }
  const removeCouponV2 = async () => {
    setApplyingV2(true)
    setErrorV2('')
    try {
      await removeCouponFromCart(cartIdV2, appliedV2?.cupon_id || appliedV2?.couponId)
      await syncLocalCartDiscounts(cartIdV2)
      window.location.reload()
    } catch (e: any) {
      const data = e?.response?.data
      setErrorV2((data && (data.mensaje || data.motivo)) || (typeof data === 'string' && data) || 'No se pudo quitar el cupón')
    } finally {
      setApplyingV2(false)
    }
  }
  const renderCouponV2 = () => (
    <div style={{ padding: '10px 14px', borderTop: '1px solid #eee' }}>
      {appliedV2 ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#2e7d32', fontWeight: 600, fontSize: 14 }}>
            Cupón {appliedV2.codigo || ''} aplicado
            {appliedV2.descuento_real || appliedV2.realDiscount || appliedV2.amount
              ? ` (-${formatCurrency(appliedV2.descuento_real || appliedV2.realDiscount || appliedV2.amount)})`
              : ''}
          </span>
          {/* Auto-aplicables: sin "Quitar" (se re-aplica solo al recargar). */}
          {appliedV2.requiere_codigo !== false && (
            <button
              onClick={removeCouponV2}
              disabled={applyingV2}
              style={{ background: 'none', border: 'none', color: '#c62828', fontWeight: 600, cursor: 'pointer' }}
            >
              Quitar
            </button>
          )}
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={codigoV2}
            onChange={(e) => setCodigoV2(e.target.value)}
            placeholder="Código de cupón"
            style={{
              flex: 1,
              textTransform: 'uppercase',
              border: '1px solid #ccc',
              borderRadius: 6,
              padding: '8px 10px',
              fontSize: 14,
            }}
          />
          <button
            onClick={applyCouponV2}
            disabled={applyingV2 || !codigoV2.trim()}
            style={{
              background: '#1a237e',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {applyingV2 ? '...' : 'Aplicar'}
          </button>
        </div>
      )}
      {errorV2 ? <div style={{ color: '#c62828', fontSize: 12, marginTop: 6 }}>{errorV2}</div> : null}
    </div>
  )

  return (
    <div className="provider-list ds-content-page" key={provider?.id}>
      <Fragment>
        <div className={isMinimumFulfilled ? 'provider-summary' : 'provider-summary invalid'}>
          {nameProvider()}
          {isCardSelect() && (
            <div className="container-info-card">
              {Object.keys(paymentMethodByVendors).length > 0 &&
                Object.keys(paymentMethodByVendors.products).length > 0 &&
                Object.keys(paymentMethodByVendors.vendors).length > 0 && (
                  <div className="provider-products">{renderProducts()}</div>
                )}
              {availableCoupons.length > 0 && renderCoupons()}
              {renderCouponV2()}
              {renderBottomSheet()}
            </div>
          )}
          {!isMinimumFulfilled && doesNotMeettheMinimum()}
          {isCardSelect() && wayToPay?.length > 1 && selectPaymentMethod()}
          {totalProviderCart()}
          {isOpenTermsConditionsCoupons && (
            <TermsConditionsCoupons
              isOpen={isOpenTermsConditionsCoupons}
              closeTermsModal={closeTermsConditionsCoupons}
            />
          )}
        </div>
      </Fragment>
    </div>
  )
}

export default withRouter(CardCartNew)
